/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputLabel, Chip, Paper, UploadFileIcon, IconButton, fabClasses } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import InputAdornment from '@material-ui/core/InputAdornment';
import { MultiSelect } from 'react-multi-select-component';
import Typography from '@material-ui/core/Typography';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export default function ProductLifeCycleAddEdit(props) {

  const navigate = useNavigate();
  const { productLifeCycleID } = useParams();
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageheadername: "Add Product Life Cycle"
  });
  const [selected, setSelected] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [plantingMaterial, setPlantingMaterial] = useState([]);
  const [isSeasonal, setIsSeasonal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [productVarietyList, setProductVarietyList] = useState([]);
  const [pickingTable, setPickingTable] = useState([]);
  const [formData, setFormData] = useState({
    groupID: "0",
    productCategoryID: "0",
    cropID: "0",
    productVarietyID: "0",
    cultivationTypeID: "0",
    daystoHarvesting: "",
    harvestingPeriod: "",
    yield: 0,
    harvestingInterval: "",
    harvestingPeriodType: "0",
    noOfPickings: "",
    noOfPlants: "",
    yieldType: "0",
    seedRatesPerAcre: '',
    harvestingStartDate: '',
    harvestingEndDate: '',
    plantingMaterialTypeID: "0",
    isActive: true
  });

  const ProductSaveSchema = Yup.object().shape({
    productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('product Category Required'),
    cropID: Yup.number().min(1, 'Please Select Crop').required('Crop Required'),
    cultivationTypeID: Yup.number().min(1, 'Please Select Cultivation Type').required('Cultivation Type Required'),
    daystoHarvesting: isSeasonal == false ? Yup.string().required('Days to Harvesting Required').matches(/^[0-9\b]+$/, 'Only allow numbers') : Yup.string().notRequired(),
    harvestingPeriod: isSeasonal == false ? Yup.string().required('Harvesting Period Required').matches(/^[0-9\b]+$/, 'Only allow numbers') : Yup.string().notRequired(),
    yield: Yup.number().required('Yield Required'),
    harvestingInterval: Yup.string().required('Harvesting Interval Required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
    harvestingPeriodType: isSeasonal == false ? Yup.number().min(1, 'Please Select Harvesting Period Type').required('Harvesting Period Type Required') : Yup.string().notRequired(),
    yieldType: Yup.number().min(1, 'Please Select Yield Type').required('Yield Type Required'),
    noOfPickings: Yup.string().max(60, 'Max No of Pickings is 60').matches(/^[0-9\b]+$/, 'Only allow numbers').required('No of Pickings Required'),
    noOfPlants: Yup.string().required('No Of Plants Required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
    seedRatesPerAcre: Yup.string().required('Seed Rates Per Acre Required').matches(/^[0-9]{1,9}([.][0-9]{1,9})?$/, 'Only allow numbers'),
    harvestingStartDate: isSeasonal == true ? Yup.string().required('Harvesting Start Date') : Yup.string().notRequired(),
    harvestingEndDate: isSeasonal == true ? Yup.string().required('Harvesting End Date') : Yup.string().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      productCategoryID: formData.productCategoryID,
      cropID: formData.cropID,
      productVarietyID: formData.productVarietyID,
      cultivationTypeID: formData.cultivationTypeID,
      daystoHarvesting: formData.daystoHarvesting,
      harvestingPeriod: formData.harvestingPeriod,
      yield: formData.yield,
      harvestingInterval: formData.harvestingInterval,
      harvestingPeriodType: formData.harvestingPeriodType,
      yieldType: formData.yieldType,
      noOfPickings: formData.noOfPickings,
      noOfPlants: formData.noOfPlants,
      seedRatesPerAcre: formData.seedRatesPerAcre,
      harvestingStartDate: formData.harvestingStartDate,
      harvestingEndDate: formData.harvestingEndDate,
      plantingMaterialTypeID: formData.plantingMaterialTypeID,
      isActive: formData.isActive
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        trackPromise(UpdateProductLifeCycle(values));
      } else {
        trackPromise(SaveProductLifeCycle(values));
      }
    },
  });
  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function SaveProductLifeCycle(values) {
    const found = pickingTable.filter(y => y.quantity == "0" || y.quantityPercentage == "0");
    if (found.length == 0) {
      var res = await services.SaveProductLifeCycle(values, pickingTable, selected, isSeasonal);
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/productLifeCycle');
        }, 3000);
      } else {
        toast.error(res.message);
      }
    }
    else {
      toast.error("Please fill the picking table");
    }
  }

  async function UpdateProductLifeCycle(values) {
    const found = pickingTable.filter(y => y.quantity == "" || y.quantityPercentage == "");
    if (found.length == 0) {
      var res = await services.UpdateProductLifeCycle(values, pickingTable, pageProps.editingID, isSeasonal);
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/productLifeCycle');
        }, 3000);
      } else {
        toast.error(res.message);
      }
    }
    else {
      toast.error("Please fill the picking table");
    }
  }

  let decrypted = 0;
  useEffect(() => {
    decrypted = AESDecryptionParam(productLifeCycleID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        pageheadername: "Update Product Life Cycle",
        editingID: parseInt(decrypted)
      })
      trackPromise(getproductLifeCycle(parseInt(decrypted)));
    }
    trackPromise(GetProductCategoties());
    trackPromise(GetPlantingMaterialDetails());
  }, []);

  useEffect(() => {
    trackPromise(generatePickingTable())
  }, [formik.values.noOfPickings]);

  useEffect(() => {
    trackPromise(GetProductDetails(formik.values.productCategoryID));
  }, [formik.values.productCategoryID]);

  useEffect(() => {
    if (formik.values.cropID !== "0") {
      trackPromise(GetAllProductVarietyByProductID(formik.values.cropID));
      let result = productList.find(x => x.productID == formik.values.cropID);
      setIsSeasonal(result == undefined ? false : result.isSeasonal);
    }
  }, [formik.values.cropID]);

  async function GetProductCategoties() {
    var res = await services.GetProductCategoties()
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetPlantingMaterialDetails() {
    var res = await services.GetPlantingMaterialDetailsForDropDown()
    if (res != null) {
      setPlantingMaterial(res);
    }
  }

  async function GetProductDetails(ProductCategoryID) {
    var res = await services.GetProductDetails(ProductCategoryID);
    if (res != null) {
      setProductList(res);
    }
  }

  async function GetAllProductVarietyByProductID(productID) {
    var res = await services.GetAllProductVarietyByProductID(productID);
    var res1 = await services.GetProductLifeCycleDetails(formik.values.productCategoryID, formik.values.cropID)
    if (res1.length == 0) {
      if (pageProps.isEdit == false) {
        const array = [];
        res.forEach(x => {
          var model = {
            label: x.varietyName,
            value: x.productVarietyID
          }
          array.push(model);
        });
        if (res != null) {
          setProductVarietyList(array);
        }
      }
      else {
        setProductVarietyList(res);
      }
    }
    else {
      const results = res.filter(x => !res1.some(y => parseInt(y.productVarietyID) === parseInt(x.productVarietyID)));
      if (pageProps.isEdit == false) {
        const array = [];
        results.forEach(x => {
          var model = {
            label: x.varietyName,
            value: x.productVarietyID
          }
          array.push(model);
        });
        if (results != null) {
          setProductVarietyList(array);
        }
      }
      else {
        setProductVarietyList(res);
      }
    }
  }

  async function getproductLifeCycle(productLifeCycleID) {
    var data = await services.GetProductLifeCycleDetailsByProductLifeCycleID(productLifeCycleID)
    setValues({
      productCategoryID: data.productCategoryID,
      cropID: data.productID,
      productVarietyID: data.productVarietyID,
      plantingMaterialTypeID: data.plantingMaterialTypeID,
      cultivationTypeID: data.cultivationTypeID,
      daystoHarvesting: data.daysToHarvest,
      extent: data.extent,
      harvestingPeriod: data.harvestingPeriod,
      yield: data.yield,
      harvestingInterval: data.harvestingIntervals,
      extentUnit: data.extentUnit,
      harvestingPeriodType: data.harvestingPeriodType,
      yieldType: data.yieldUnit,
      noOfPickings: data.noOfPickings,
      noOfPlants: data.noOfPlants,
      seedRatesPerAcre: data.seedRatesPerAcre,
      harvestingStartDate: data.harvestingStartDate.split("T")[0],
      harvestingEndDate: data.harvestingEndDate.split("T")[0],
      isActive: data.isActive
    })
    setIsSeasonal(data.isSeasonal);
    var array = [];
    data.pickingsList.forEach(x => {
      let model = {
        rowIndex: x.orderBy,
        picking: x.orderBy == 0 ? x.orderBy + 1 + 'st'
          : x.orderBy == 1 ? x.orderBy + 1 + 'nd'
            : x.orderBy == 2 ? x.orderBy + 1 + 'rd'
              : x.orderBy + 1 + 'th',
        quantity: x.quantity,
        quantityPercentage: x.quantityPercentage
      };
      array.push(model);
    });
    setPickingTable(array)
  }

  async function generatePickingTable() {
    if (pageProps.isEdit != true) {
      if (formik.values.noOfPickings <= 60) {
        var array = [];
        for (let index = 0; index < formik.values.noOfPickings; index++) {
          let model = {
            rowIndex: index,
            picking: index == 0 ? index + 1 + 'st'
              : index == 1 ? index + 1 + 'nd'
                : index == 2 ? index + 1 + 'rd'
                  : index + 1 + 'th',
            quantity: '0',
            quantityPercentage: '0'
          };
          array.push(model);
        }
        setPickingTable(array)
      }
    }
    else {
      if (formik.values.noOfPickings <= 60) {
        const index2 = pickingTable.length;
        const index3 = parseInt(formik.values.noOfPickings) - parseInt(index2);
        const index4 = index3 + index2
        var array = [...pickingTable];
        for (let index = index2; index < index4; index++) {
          let model = {
            rowIndex: index,
            picking: index == 0 ? index + 1 + 'st'
              : index == 1 ? index + 1 + 'nd'
                : index == 2 ? index + 1 + 'rd'
                  : index + 1 + 'th',
            quantity: '0',
            quantityPercentage: '0'
          };
          array.push(model);
        }
        setPickingTable(array)
      }
    }
  }

  function changeText(e, rowID, inputType) {
    const target = e.target;
    const value = target.value
    const newArr = [...pickingTable];
    var idx = newArr.findIndex(e => e.rowIndex == parseInt(rowID));

    if (inputType == "quantity") {
      newArr[idx] = { ...newArr[idx], quantity: value == "" ? parseInt(0) : parseFloat(value) };
      var totQuantity = 0;

      newArr.forEach(element => {
        totQuantity = totQuantity + parseFloat(element.quantity);
      });

      for (let i = 0; i < newArr.length; i++) {
        totQuantity > 0 ? newArr[i] = { ...newArr[i], quantityPercentage: ((newArr[i].quantity / totQuantity) * 100).toString() } :
          newArr[i] = { ...newArr[i], quantityPercentage: '0' };
      }
      formik.values.yield = totQuantity.toString();
    }
    setPickingTable(newArr)
  }

  function handleDelete(e, rowIndex) {
    var array = [...pickingTable];
    var index = array.findIndex(obj => obj.rowIndex === rowIndex);
    array.splice(index, 1);

    var totQuantity = 0;
    array.forEach(element => {
      totQuantity = totQuantity + parseFloat(element.quantity);
    });
    for (let i = 0; i < array.length; i++) {
      array[i] = {
        ...array[i],
        rowIndex: i,
        quantity: array[i].quantity,
        quantityPercentage: ((array[i].quantity / totQuantity) * 100).toString(),
        picking: i == 0 ? i + 1 + 'st'
          : i == 1 ? i + 1 + 'nd'
            : i == 2 ? i + 1 + 'rd'
              : i + 1 + 'th'
      }
    }
    formik.values.yield = totQuantity.toString();
    formik.values.noOfPickings = array.length;
    setPickingTable(array)
  }

  function generatePlantingMaterialDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(x.isActive == true ? <MenuItem key={x.plantingMaterialTypeID} value={x.plantingMaterialTypeID}>{x.plantingMaterialTypeName}</MenuItem> : null)
      });
    }
    return items
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Add Product Life Cycle  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard/productLifeCycle/"
            btname="Back"
            pageName={pageProps.pageheadername}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} >

                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Product Category *"
                    value={formik.values.productCategoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('productCategoryID')}
                    error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                    helperText={touched.productCategoryID && errors.productCategoryID}
                    InputProps={{
                      readOnly: pageProps.isEdit == true
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                    {productcatogery.map((option) => (
                      option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                        {option.productCategoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Planting Material Type"
                    value={formik.values.plantingMaterialTypeID}
                    onChange={formik.handleChange}
                    {...getFieldProps('plantingMaterialTypeID')}
                    error={Boolean(touched.plantingMaterialTypeID && errors.plantingMaterialTypeID)}
                    helperText={touched.plantingMaterialTypeID && errors.plantingMaterialTypeID}
                  >
                    <MenuItem key={0} value={0}> Select Planting Material Type</MenuItem>
                    {generatePlantingMaterialDropDownMenu(plantingMaterial)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Crop *"
                    value={formik.values.cropID}
                    onChange={formik.handleChange}
                    {...getFieldProps('cropID')}
                    error={Boolean(touched.cropID && errors.cropID)}
                    helperText={touched.cropID && errors.cropID}
                    InputProps={{
                      readOnly: pageProps.isEdit == true
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Crop</MenuItem>
                    {productList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.productID} value={option.productID}>
                        {option.productName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {pageProps.isEdit == false ? (
                    <Stack width={1150}>
                      <MultiSelect
                        options={productVarietyList}
                        value={selected}
                        onChange={setSelected}
                        labelledBy="Crop Variety *"
                      />
                    </Stack>
                  ) : null}
                  {pageProps.isEdit == true ? (
                    <TextField select
                      fullWidth
                      size="small"
                      label="Crop Variety *"
                      value={formik.values.productVarietyID}
                      onChange={formik.handleChange}
                      {...getFieldProps('productVarietyID')}
                      error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                      helperText={touched.productVarietyID && errors.productVarietyID}
                      InputProps={{
                        readOnly: true
                      }}
                    >
                      <MenuItem key={0} value={0}>Select Crop</MenuItem>
                      {productVarietyList.map((option) => (
                        <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                          {option.varietyName}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : null}
                  {pageProps.isEdit == true ? (
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Cultivation Type *"
                      value={formik.values.cultivationTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('cultivationTypeID')}
                      error={Boolean(touched.cultivationTypeID && errors.cultivationTypeID)}
                      helperText={touched.cultivationTypeID && errors.cultivationTypeID}
                      InputProps={{
                        readOnly: true
                      }}
                    >
                      <MenuItem key={0} value={0}> Select Cultivation Type</MenuItem>
                      <MenuItem value={1}> Greenhouse</MenuItem>
                      <MenuItem value={2}> Non Greenhouse</MenuItem>
                    </TextField>
                  ) :
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Cultivation Type *"
                      value={formik.values.cultivationTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('cultivationTypeID')}
                      error={Boolean(touched.cultivationTypeID && errors.cultivationTypeID)}
                      helperText={touched.cultivationTypeID && errors.cultivationTypeID}
                    >
                      <MenuItem key={0} value={0}> Select Cultivation Type</MenuItem>
                      <MenuItem value={1}> Greenhouse</MenuItem>
                      <MenuItem value={2}> Non Greenhouse</MenuItem>
                    </TextField>}
                  {isSeasonal == false ?
                    <TextField
                      fullWidth
                      size="small"
                      label="Days to Harvesting *"
                      value={formik.values.daystoHarvesting}
                      onChange={formik.handleChange}
                      {...getFieldProps('daystoHarvesting')}
                      error={Boolean(touched.daystoHarvesting && errors.daystoHarvesting)}
                      helperText={touched.daystoHarvesting && errors.daystoHarvesting}
                    /> : null}
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {isSeasonal == false ?
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Harvesting Period Type *"
                      value={formik.values.harvestingPeriodType}
                      onChange={formik.handleChange}
                      {...getFieldProps('harvestingPeriodType')}
                      error={Boolean(touched.harvestingPeriodType && errors.harvestingPeriodType)}
                      helperText={touched.harvestingPeriodType && errors.harvestingPeriodType}
                    >
                      <MenuItem key={0} value={0}> Select Harvesting Period Type</MenuItem>
                      <MenuItem value={1}> Days</MenuItem>
                      <MenuItem value={2}> Weeks</MenuItem>
                      <MenuItem value={3}> Months</MenuItem>
                    </TextField> : null}
                  {isSeasonal == true ?
                    <TextField
                      fullWidth
                      type='date'
                      size="small"
                      label="Harvesting Start Date *"
                      value={formik.values.harvestingStartDate}
                      onChange={formik.handleChange}
                      {...getFieldProps('harvestingStartDate')}
                      error={Boolean(touched.harvestingStartDate && errors.harvestingStartDate)}
                      helperText={touched.harvestingStartDate && errors.harvestingStartDate}
                      InputLabelProps={{ shrink: true }}
                    /> : null}
                  {isSeasonal == true ?
                    <TextField
                      fullWidth
                      type='date'
                      size="small"
                      label="Harvesting End Date *"
                      value={formik.values.harvestingEndDate}
                      onChange={formik.handleChange}
                      {...getFieldProps('harvestingEndDate')}
                      error={Boolean(touched.harvestingEndDate && errors.harvestingEndDate)}
                      helperText={touched.harvestingEndDate && errors.harvestingEndDate}
                      InputLabelProps={{ shrink: true }}
                    /> : null}

                  {isSeasonal == false ?
                    <TextField
                      fullWidth
                      size="small"
                      label="Harvesting Period *"
                      value={formik.values.harvestingPeriod}
                      onChange={formik.handleChange}
                      {...getFieldProps('harvestingPeriod')}
                      error={Boolean(touched.harvestingPeriod && errors.harvestingPeriod)}
                      helperText={touched.harvestingPeriod && errors.harvestingPeriod}
                    /> : null}
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Yield Type *"
                    value={formik.values.yieldType}
                    onChange={formik.handleChange}
                    {...getFieldProps('yieldType')}
                    error={Boolean(touched.yieldType && errors.yieldType)}
                    helperText={touched.yieldType && errors.yieldType}
                  >
                    <MenuItem key={0} value={0}> Select Yield Type</MenuItem>
                    <MenuItem value={1}> Unit</MenuItem>
                    <MenuItem value={2}> Kg</MenuItem>
                  </TextField>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Harvesting Interval (Days) *"
                    value={formik.values.harvestingInterval}
                    onChange={formik.handleChange}
                    {...getFieldProps('harvestingInterval')}
                    error={Boolean(touched.harvestingInterval && errors.harvestingInterval)}
                    helperText={touched.harvestingInterval && errors.harvestingInterval}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="No of Plants *"
                    value={formik.values.noOfPlants}
                    onChange={formik.handleChange}
                    {...getFieldProps('noOfPlants')}
                    error={Boolean(touched.noOfPlants && errors.noOfPlants)}
                    helperText={touched.noOfPlants && errors.noOfPlants}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="Seed Rates Per Acre *"
                    value={formik.values.seedRatesPerAcre}
                    onChange={formik.handleChange}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">g</InputAdornment>,
                    }}
                    {...getFieldProps('seedRatesPerAcre')}
                    error={Boolean(touched.seedRatesPerAcre && errors.seedRatesPerAcre)}
                    helperText={touched.seedRatesPerAcre && errors.seedRatesPerAcre}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="No of Pickings *"
                    value={formik.values.noOfPickings}
                    onChange={formik.handleChange}
                    {...getFieldProps('noOfPickings')}
                    error={Boolean(touched.noOfPickings && errors.noOfPickings)}
                    helperText={touched.noOfPickings && errors.noOfPickings}
                  />
                </Stack>
                <Divider variant="middle" />
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        value={formik.values.isActive}
                        checked={formik.values.isActive}
                        {...getFieldProps('isActive')}
                        onClick={formik.handleChange}
                        color="error"
                        name="isActive"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />}
                    label="Is Active"
                  />
                </Stack>
              </Stack>
              {pickingTable.length > 0 ?
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Card style={{ justifycontent: 'center', width: '85rem' }} >
                    <TableContainer component={Paper} >
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Pickings</TableCell>
                            <TableCell align="center">Quantity</TableCell>
                            <TableCell align="center">Quantity Percentage</TableCell>
                            {pageProps.isEdit == true ? <TableCell align="center">Action</TableCell> : null}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            pickingTable.map((object) => {
                              let ID = object.rowIndex
                              return (
                                <TableRow key={object.picking}>
                                  <TableCell align="center">
                                    {object.picking}
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      style={{ width: '7rem' }}
                                      variant="outlined"
                                      size={"small"}
                                      name={ID}
                                      onChange={(e) => changeText(e, object.rowIndex, "quantity")}
                                      value={object.quantity}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="h6" gutterBottom>
                                      {parseFloat(object.quantityPercentage).toFixed(1)} %
                                    </Typography>
                                  </TableCell>
                                  {pageProps.isEdit == true ?
                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={(e) => handleDelete(e, object.rowIndex)} >
                                      <DeleteIcon />
                                    </IconButton>}</TableCell> : null}
                                </TableRow>
                              )
                            })
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br />
                    <Stack direction={{ xs: 'column', sm: 'row' }} width={370} margin={2}>
                      <Typography variant="h6" gutterBottom>
                        Yield (Potential) : {formik.values.yield}
                      </Typography>
                    </Stack>
                  </Card>
                </Stack>
                : null}
              <br />
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <LoadingButton
                  size="medium"
                  type="submit"
                  color='secondary'
                  variant="contained"
                  disabled={formik.values.noOfPickings == 0}
                >
                  {pageProps.submitButtonName}
                </LoadingButton>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}